import { useSelector } from "react-redux";
import { ExtractFnReturnType, QueryConfig } from "../../../lib/react-query";
import { RootState } from "../../../redux/store";
import { getClaimIndicatorsTimeTracking } from "../api/ClaimAPI";
import { useQuery } from "@tanstack/react-query";
import { PaginationFilterDto } from "../../../types/Pagination";

type QueryFnTypeClaimIndicatorsTimeTracking = typeof getClaimIndicatorsTimeTracking;

export const useClaimIndicatorsTimeTracking = (config?: QueryConfig<QueryFnTypeClaimIndicatorsTimeTracking>) => {
    const filters = useSelector((state: RootState) => state.filters.claims.selectedFilters);
    const currentUser = useSelector((state: RootState) => state.currentUserInfo.data);

    const paginationFilters: PaginationFilterDto = {
        filters,
        selectedOrganizationalStructureIds: currentUser.selectedOrganizationalStructureIds,
        pageNumber: 1,
        pageSize: 1
    };

    return useQuery<ExtractFnReturnType<QueryFnTypeClaimIndicatorsTimeTracking>>({
        ...config,
        refetchOnMount: false,
        refetchOnWindowFocus: false,
        retry: false,
        queryKey: ["claimIndicatorsTimeTracking", filters, currentUser],
        queryFn: () => getClaimIndicatorsTimeTracking(paginationFilters), 
    });
}